export default __webpack_public_path__ + "static/info_ru-f9b32815d71079094e3e61c3f298ad66.png";